<div class="container home-container">
    <router-outlet></router-outlet>
</div>
